// Is there work on screen that a reload would throw away? Read by the
// service-worker update handler in index.js before it reloads into a new
// deploy (audit OPS-9). Deliberately conservative: a false "yes" only means
// the "new version" bar is shown instead of an automatic reload.
//
// Two signals:
//   - window.__pmDirty, a counter anything can hold open while it has a
//     draft (markDirty() returns the release). Every Modal holds one, since
//     most create/edit forms live in one.
//   - the last field typed into (or canvas drawn on, e.g. a signature pad)
//     is still on the page. Once a form saves and unmounts it is gone.

let lastEdited = null;

export function markDirty() {
  window.__pmDirty = (window.__pmDirty || 0) + 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    window.__pmDirty = Math.max(0, (window.__pmDirty || 0) - 1);
  };
}

export function trackEdits() {
  const note = (e) => {
    const t = e.target;
    if (!t || !t.tagName) return;
    if (e.type === "pointerdown" && t.tagName !== "CANVAS") return;
    lastEdited = t;
  };
  document.addEventListener("input", note, true);
  document.addEventListener("pointerdown", note, true);
}

export function hasUnsavedWork() {
  if ((window.__pmDirty || 0) > 0) return true;
  return !!(lastEdited && lastEdited.isConnected);
}
